import { render } from "./ReservationsHeader.vue?vue&type=template&id=63dcbef0&scoped=true"
import script from "./ReservationsHeader.vue?vue&type=script&lang=js"
export * from "./ReservationsHeader.vue?vue&type=script&lang=js"

import "./ReservationsHeader.vue?vue&type=style&index=0&id=63dcbef0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dcbef0"]])

export default __exports__